const locale = require('./userProfileButton.i18n.json');

/*@ngInject*/
const UserProfileButtonController = function ($scope, $element, $window, loginRepository, headerConstant, coreMediator, coreConstant, preferenceModel, userStateModel) {

    this.i18n = locale;

    $element.addClass('userProfileButton');

    this.isOpen = false;
    this.visibleForChat = userStateModel.isVisibleForChat();

    window.onunload = function() {
        console.log("onunload...");
        fetch('/rest/Session/preDestroy', {
          method:'post',
          headers:{
            "Authorization": coreMediator.getLoginTokenAuthorizationHeader()
          },
          keepalive: true // this is important to make sure the request is sent!
        });
    };

    this.onIconClick = function () {
        this.isOpen = !this.isOpen;
    };

    this.loadProfileInfo = function () {
        coreMediator.loadUserProfile().then((userProfile) => {
            this.userId = userProfile.userId;
            this.firstName = userProfile.firstName;
        });
    };

    $scope.$on(coreConstant.event.CHAT_VISIBILITY_CHANGED, () => {
        this.visibleForChat = userStateModel.isVisibleForChat();
    });

    $scope.$on(headerConstant.event.CLOSE_USER_PROFILE_DROPDOWN, () => {
        this.isOpen = false;
    });

    this.loadProfileInfo();
};

angular.module('gw-um-header')
    .controller('userProfileButtonController', UserProfileButtonController);
